import type { AuthProviderFeatures } from '../../types';

export const COGNITO_FEATURES: AuthProviderFeatures = {
  canUpdateProfile: true,
  canUpdateEmail: true,
  canChangePassword: true,
  canDeleteAccount: true,
  forgotPasswordFlow: 'confirm_in_app',
  emailChangeConfirmation: 'verification_code',
  socialSignInFlow: 'idp_redirect',
  socialProviders: ['google', 'facebook', 'apple'],
  requiresSessionGuard: true,
};
